import React from 'react';

export const ArrowDownIcon = ({ width = 25, height = 25, color = "black", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 25 25"
            fill="none"
        >
            <path
                className={className}
                d="M7.19995 10.5L12.2 15.5L17.2 10.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};